<template>
    <div>
        <b-modal ref="createTicket" id="createTicket" size="lg" @hide="onHide" @show="onShow" top :title="type === 'updateTicket' ? $t('updateNonconformityTicketTitle'): $t('createNonconformityTicketTitle')">
            <b-row class="mt-1">
                <b-col style="text-align: left; font-weight: bold">
                    <span>{{ $t('nonconformity') }}</span>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-form-input v-model="scope" @focus.native="errors.scope = false" :class="{'is-invalid': errors.scope }"/>
                </b-col>
            </b-row>
            <b-row class="mt-4">
                <b-col style="text-align: left;font-weight: bold">
                    <span>{{ $t('nonconformanceType') }}</span>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-form-select v-model="nonconformanceId" @change="selectNonconformance" @focus.native="errors.nonconformanceId = false" :class="{'is-invalid': errors.nonconformanceId }">
                        <option :value="null" :disabled="true">{{ $t('choose') }}</option>
                        <option v-for="item in nonconformancesOptions()" :value="item.id">
                            {{$t(item.article)}}
                        </option>
                    </b-form-select>
                </b-col>
            </b-row>
            <b-row class="mt-4">
                <b-col style="text-align: left;font-weight: bold">
                    <label>{{ $t('urgentActionText') }}</label>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-form-textarea v-model="urgentActionText" placeholder="" :rows="2" :max-rows="6"/>
                </b-col>
            </b-row>
            <b-row class="mt-4">
                <b-col style="text-align: left;font-weight: bold">
                    <label>{{ $t('reasonAnalysisText') }}</label>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-form-textarea v-model="reasonAnalysisText" placeholder="" :rows="3" :max-rows="6"/>
                </b-col>
            </b-row>
            <b-row v-if="nonconformanceId" class="mt-4">
                <b-col style="text-align: left;font-weight: bold">
                    <label>{{ $t('action') }}</label>
                </b-col>
            </b-row>
            <b-row v-if="nonconformanceId">
                <b-col>
                    <b-form-textarea v-model="customNonconformance" rows="4" :readonly="nonconformanceId !== 13"/>
                </b-col>
            </b-row>
            <b-row class="mt-4">
                <b-col style="text-align: left;font-weight: bold">
                    <label>{{ $t('revisedDocumentInfo') }}</label>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-form-textarea v-model="revisedDocText" placeholder="" :rows="5" :max-rows="6"/>
                </b-col>
            </b-row>
            <b-row class="mt-4">
                <b-col style="text-align: left;font-weight: bold">
                    <label>{{ $t('auditDate') }}</label>
                </b-col>
            </b-row>
            <b-row>
                <b-col style="text-align: left;">
                    <el-date-picker
                        v-model="auditDate"
                        @change="setpredictedDate($event)"
                        type="date"
                        :readonly="false"
                        format="dd/MM/yyyy"
                        style="width: 100%"
                        :placeholder="$t('chooseDatePlaceholder')"
                        @focus="errors.auditDate = false"
                        :class="{'is-invalid': errors.auditDate }"
                    >
                    </el-date-picker>
                </b-col>
            </b-row>
            <b-row class="mt-4">
                <b-col style="text-align: left;font-weight: bold">
                    <span style="align-self: center">{{ $t('predictedDate') }}</span>
                </b-col>
            </b-row>
            <b-row>
                <b-col style="text-align: left;">
                    <el-date-picker
                        v-model="expectedDate"
                        type="date"
                        :readonly="false"
                        format="dd/MM/yyyy"
                        style="width: 100%; align-self: center"
                        :placeholder="$t('chooseDatePlaceholder')"
                        @focus="errors.expectedDate = false"
                        :class="{'is-invalid': errors.expectedDate }"
                    />
                </b-col>
            </b-row>
            <b-row class="mt-4">
                <b-col style="text-align: left;font-weight: bold">
                    <label>{{ $t('note') }}:</label>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-form-textarea v-model="note" placeholder="" :rows="5" :max-rows="6"/>
                </b-col>
            </b-row>
            <b-row class="mt-4">
                <b-col style="text-align: left;font-weight: bold">
                    <label>{{$t('additionalFiles')}}:</label>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-row align-h="start" no-gutters>
                        <template v-if="postDocuments.length">
                            <template v-for="(file, index) in postDocuments">
                                <b-col cols="1" v-bind:key="`upload-${index}`" style="text-align: center">
                                    <upload 
                                        fileCategory="audit-report"
                                        :showUpload="false" 
                                        :showDownload="false" 
                                        :reactive-id="`${reactiveId}-${file.uuid}-${index}`" 
                                        :deleteFromDB="true"
                                        :dataId="file.id"
                                        @onremove="handleRemoving($event, file)"/>
                                    <div style="font-size: 12px;">{{file.filename | textToShortText}}</div>
                                </b-col>
                            </template>
                        </template>
                        <b-col cols="1" style="text-align: left">
                            <upload-regular 
                                fileCategory="audit-report"
                                @onupload="onupload"/>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button v-if="type === 'updateTicket'" @click="update()" variant="Primary">{{ $t('update') }}</b-button>
                <b-button v-else @click="insert()" variant="Primary">{{ $t('save') }}</b-button>
                <b-button @click="closeModal(true)" variant="Danger">{{ $t('cancel') }}</b-button>
            </div>
        </b-modal>
        <!-- action type: -->
        <b-modal
            ref="createAction"
            id="createAction"
            size="lg"
            @show="onShow"
            top
            :title="type === 'updeteTicket' ? $t('updateActionTicketTitle'): $t('createActionTicketTitle')"
        >
            <b-row class="mt-4" >
                <b-col style="text-align: left;font-weight: bold">
                    <label>{{ $t('nonconformity') }}</label>
                </b-col>
            </b-row>
            <b-row >
                <b-col>
                    <b-form-textarea v-model="revisedDocText" placeholder :rows="1" :max-rows="6" :class="{'is-invalid': actionErrors.revisedDocText }" />
                </b-col>
            </b-row>
            <b-row class="mt-4" >
                <b-col style="text-align: left;font-weight: bold">
                    <label>{{$t('futureAction')}}</label>
                </b-col>
            </b-row>
            <b-row @blur="()=>{this.isCustomSelectOpen=false;}" style="padding-bottom: 20px">
                <b-col>
                    <div class="custom-select-choose" @click="()=>{customSelectScroll();this.isCustomSelectOpen=!this.isCustomSelectOpen}" 
                        :class="{'is-invalid': actionErrors.actionCheckList }">{{$t('choose')}}<div class="arrow-up"/><div class="arrow-down"/></div>
                    <div id="custom-select-options" :class="isCustomSelectOpen?'custom-select-options-show':'custom-select-options-hide'">
                        <div v-for="item in nonconformancesOptions()" :value="item.id" v-if="(item.id!=13)">
                            <b-row class="custom-select-row" @click="setActionCheckList(item.id)">
                                <b-col sm="1" class="custom-select-checkbox-col" v-if="gbId($store.state.user.customerId)">
                                    <input type="checkbox" class="custom-select-checkbox" :checked="actionCheckList[(item.id-getNewNonconformanceId)]"/>
                                </b-col>
                                <b-col sm="1" class="custom-select-checkbox-col" v-if="!gbId($store.state.user.customerId)">
                                    <input type="checkbox" class="custom-select-checkbox" :checked="actionCheckList[(item.id)]"/>
                                </b-col>
                                <b-col sm="11" class="custom-select-action-text">
                                    {{$t(item.action)}}
                                </b-col>
                            </b-row>
                        </div>
                    </div>
                </b-col>
            </b-row>
            <b-row >
                <b-col>
                    <b-form-textarea
                        v-model="responseActionText"
                        placeholder
                        :rows="8"
                        readonly
                    />
                </b-col>
            </b-row>
            <b-row class="mt-4" >
                <b-col style="text-align: left;font-weight: bold">
                    <label>{{ $t('note') }}:</label>
                </b-col>
            </b-row>
            <b-row >
                <b-col>
                    <b-form-textarea v-model="note" placeholder :rows="5" :max-rows="6" />
                </b-col>
            </b-row>
            <b-row class="mt-4" >
                <b-col style="text-align: left;font-weight: bold">
                    <span style="align-self: center">{{ $t('predictedDate') }}</span>
                </b-col>
            </b-row>
            <b-row class="mt-4" >
                <b-col style="text-align: left;">
                    <el-date-picker
                        v-model="expectedDate"
                        type="date"
                        :readonly="false"
                        format="dd/MM/yyyy"
                        style="width: 100%; align-self: center"
                        :placeholder="$t('chooseDatePlaceholder')"
                        :class="{'is-invalid': actionErrors.expectedActionDate }"
                    />
                </b-col>
            </b-row>
            <div slot="modal-footer" >
                <b-button
                    v-if="type === 'updateTicket'"
                    @click="update()"
                    variant="Primary"
                >{{ $t('update') }}</b-button>
                <b-button v-else @click="insert()" variant="Primary">{{ $t('save') }}</b-button>
                <b-button @click="$refs.createAction.hide()" variant="Danger">{{ $t('cancel') }}</b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import uuid from 'uuid/v4';
import Upload from '../../components/Upload';
import UploadRegular from '../../components/UploadRegular';
import _ from 'lodash';
import moment from 'moment';

export default {
    name: 'createTicket',
    components: {UploadRegular, Upload},
    data() {
        return {
            eventId: null,
            compId: uuid(),
            expectedDate: moment
                .utc(new Date())
                .add(1, 'M')
                .toDate(),
            expectedActionDate: new Date(),
            auditDate: new Date(),
            actionCheckList: [
                false,
                false,
                false,
                false,
                false,
                false,
                false,
                false,
                false,
                false,
                false,
                false
            ],
            isCustomSelectOpen: false,
            postDocuments: [],
            revisedDocText: null,
            note: null,
            responseActionText: '',
            urgentActionText: null,
            reasonAnalysisText: null,
            scope: null,
            nonconformanceId: null,
            reactiveId: uuid(),
            siteId: null,
            type: null,
            ticketId: null,
            customNonconformance: null,
            ticketType: null,
            errors: {
                scope: false,
                nonconformanceId: false,
                expectedDate: false,
                auditDate: false
            },
            actionErrors: {
                revisedDocText: false,
                actionCheckList: false,
                expectedActionDate: false,
            }
        };
    },
    methods: {
        customSelectScroll() {
            var options = document.querySelector('.custom-select-options-show');
            if (options) {
                options.scrollTop = 0;
            }
        },
        setActionCheckList(index) {

            if(this.gbId(this.$store.state.user.customerId)){
                this.actionCheckList = [
                    ...this.actionCheckList.slice(0, (index-this.getNewNonconformanceId)),
                    !this.actionCheckList[index],
                    ...this.actionCheckList.slice((index-this.getNewNonconformanceId) + 1)
                ];
                this.responseActionText = '';
                _.each(this.actionCheckList, (actionCheck, actionIndex) => {
                    if (actionCheck) {
                        this.responseActionText +=
                            '→ ' + this.$store.state.nonconformances[(actionIndex+13) - 1].action + '\n';
                    }
                });
            }
            if(!this.gbId(this.$store.state.user.customerId)){
                this.actionCheckList = [
                    ...this.actionCheckList.slice(0, index),
                    !this.actionCheckList[index],
                    ...this.actionCheckList.slice(index + 1)
                ];
                this.responseActionText = '';
                _.each(this.actionCheckList, (actionCheck, actionIndex) => {
                    if (actionCheck) {
                        this.responseActionText +=
                            '→ ' + this.$t(this.$store.state.nonconformances[actionIndex - 1].action) + '\n';
                    }
                });
            }
            
        },
        onBlurCustomSelect() {
            this.isCustomSelectOpen = false;
        },
        setpredictedDate(event) {
            this.expectedDate = moment(event)
                .utc()
                .add(1, 'M')
                .toDate();
        },
        onupload(event) {
            this.postDocuments.push({
                id: event.id,
                filename: event.filename,
                uuid: event.fileId,
                fileUrl: event.fileUrl
            });
        },
        handleRemoving(event, file) {
            this.postDocuments =_.remove(this.postDocuments, function(nFile){
                return _.get(file, 'uuid') != _.get(nFile, 'uuid') || _.get(file, 'fileId') != _.get(nFile, 'fileId');
            });
            
        },
        onHide(event){
            if(_.get(event, 'trigger') != null){
                this.closeModal(true);
            }
        },
        closeModal(deleteFiles=false) {
            if(deleteFiles){
                let fileIds = _.map(_.filter(this.postDocuments, docs=> _.includes(Object.keys(docs), 'id')), 'id');
                this.axios.post('/deleteFilesFromAWS',{files:fileIds}).then(()=>{
                    this.$refs.createTicket.hide();
                    this.$refs.createAction.hide();
                });
            }
            else{
                this.$refs.createTicket.hide();
                this.$refs.createAction.hide();
            }
        },
        // Validate required fields and return boolean of audit and action type ticket.
        validateAudit() {
            if (this.ticketType == 'Audit') {
                for (let key in this.errors) {
                    this.errors[key] = !this[key];
                }
                // checks true value count of erros object 
                return !Object.values(this.errors).filter(value => {
                    return !!value;
                }).length;
            }  else if(this.ticketType == 'Action'){
                this.actionErrors.actionCheckList = _.every(this.actionCheckList, o => o === false );
                this.actionErrors.revisedDocText = !this.revisedDocText;
                this.actionErrors.expectedActionDate = !this.expectedDate;
                let validation = true;
                for (let key in this.actionErrors) {
                    validation &= !this.actionErrors[key];
                }
                return validation;
                
            } else return true;
        },
        insert() {
            if (this.validateAudit()) {
                let newAudit = {
                    auditDate: this.createUTCDate(
                        this.auditDate.getFullYear(),
                        this.auditDate.getMonth(),
                        this.auditDate.getDate()
                    ),
                    expectedDate: this.createUTCDate(
                        this.expectedDate.getFullYear(),
                        this.expectedDate.getMonth(),
                        this.expectedDate.getDate()
                    ),
                    textInput: this.revisedDocText,
                    urgentActionInput: this.urgentActionText,
                    reasonAnalysisInput: this.reasonAnalysisText,
                    ticketType: this.ticketType,
                    note: this.note,
                    scope: this.responseActionText ? this.responseActionText : this.scope,
                    nonconformanceId: this.nonconformanceId,
                    customNonconformance: this.customNonconformance,
                    documentIds: this.postDocuments.map(document => {
                        return document.uuid;
                    })
                };
                if (this.ticketType === 'Action') {
                    newAudit.scope = JSON.stringify(this.actionCheckList);
                }
                return this.axios.post(`/${this.siteId}/audits`, newAudit).then(({data}) => {
                    let actions = '';
                    try {
                        data.actionCheckList = data.scope;
                        _.each(JSON.parse(data.scope), (actionCheck, actionIndex) => {
                            if (actionCheck) {
                                actions +=
                                    '→ ' +
                                    this.$t(this.$store.state.nonconformances[actionIndex - 1].action) +
                                    '\n';
                            }
                        });
                        data.scope = actions;
                    } catch (error) {
                        console.error(error);
                    }
                    this.$eventHub.$emit(this.$store.state.modal.eventId, data);
                    this.closeModal(false);
                });
            } else {
                this.$toasted.error(this.$t('missingError'));
            }
        },
        update() {
            if (this.validateAudit()) {
                let newExpectedDate = new Date(this.expectedDate);
                let auditToBeUpdated = {
                    auditDate: this.auditDate,
                    expectedDate: this.createUTCDate(
                        newExpectedDate.getFullYear(),
                        newExpectedDate.getMonth(),
                        newExpectedDate.getDate()
                    ),
                    textInput: this.revisedDocText,
                    note: this.note,
                    urgentActionInput: this.urgentActionText,
                    reasonAnalysisInput: this.reasonAnalysisText,
                    ticketType: this.ticketType,
                    scope: this.scope ? this.scope : this.responseActionText,
                    nonconformanceId: this.nonconformanceId,
                    customNonconformance: this.customNonconformance,
                    documents: this.postDocuments
                };
                if(this.ticketType == 'Action'){
                    try {
                        auditToBeUpdated.scope = JSON.stringify(this.actionCheckList);
                    } catch (error) {
                        console.error(error);
                    }
                }
                return this.axios
                    .put(`/${this.siteId}/audits/${this.ticketId}`, auditToBeUpdated)
                    .then(({data}) => {
                        auditToBeUpdated.updatedAt = data.updatedAt;
                        this.$eventHub.$emit(this.$store.state.modal.eventId, auditToBeUpdated);
                        this.closeModal(false);
                    });
            } else {
                this.$toasted.error(this.$t('missingError'));
            }
        },
        onShow() {
            try {
                var modals = document.getElementsByClassName('modal-content');
                modals[1].addEventListener('click', event => {
                    if (!event.target.classList.value.includes('custom-select')) {
                        this.customSelectScroll();
                        this.isCustomSelectOpen = false;
                    }
                });
            } catch (error) {
                console.log(error);
            }
            Object.assign(this.$data, this.$options.data());
            this.eventId = this.$store.state.modal.eventId;
            this.siteId = this.$store.state.modal.payload.siteId || this.$store.state.siteId;
            this.ticketType =
                _.get(this.$store.state.modal.payload, 'ticketType') ||
                _.get(this.ticket, 'ticketType');
            this.type = this.$store.state.modal.type;
            if (this.type === 'updateTicket') {
                let ticket = this.$store.state.modal.payload.ticket;
                this.ticketId = this.$store.state.modal.payload.ticketId;
                this.expectedDate = ticket.expectedDate;
                this.revisedDocText = ticket.textInput;
                this.note = ticket.note;
                this.urgentActionText = ticket.urgentActionInput;
                this.reasonAnalysisText = ticket.reasonAnalysisInput;
                this.ticketType = _.get(ticket, 'ticketType');
                this.auditDate = ticket.auditDate;
                this.scope = ticket.actionCheckList || ticket.scope;
                this.nonconformanceId = ticket.nonconformanceId;
                this.customNonconformance = _.get(
                    _.find(this.$store.state.nonconformances, {id: this.nonconformanceId}),
                    'article'
                );
                this.selectNonconformance(ticket.nonconformanceId);
                if (ticket.nonconformanceId === 13) {
                    this.customNonconformance = ticket.customNonconformance;
                }
                this.postDocuments = _.cloneDeep(ticket.documents);
                try {
                    this.actionCheckList = JSON.parse(this.scope);
                    this.responseActionText = '';
                    _.each(this.actionCheckList, (actionCheck, actionIndex) => {
                        if (actionCheck) {
                            this.responseActionText +=
                                '→ ' +
                                this.$store.state.nonconformances[actionIndex - 1].action +
                                '\n';
                        }
                    });
                } catch (error) {
                    this.responseActionText = this.scope;
                }
            }
        },
        selectNonconformance(val) {
            if (
                _.get(this.$store.state.modal.payload, 'ticketType') == 'Audit' ||
                this.ticketType == 'Audit'
            ) {
                if (val !== 13) {
                    this.customNonconformance = this.$t(_.find(this.$store.state.nonconformances, {
                        id: val
                    }).action);
                } else {
                    this.customNonconformance = null;
                }
            }
        },
        nonconformancesOptions(){
            if(this.gbId(this.$store.state.user.customerId)){
                return _.filter(this.$store.state.nonconformances, item => item.id>12)
            }
            if(!this.gbId(this.$store.state.user.customerId)){
                return _.filter(this.$store.state.nonconformances, item => item.id<14)
            }
        }
    },
    computed: {
        getNewNonconformanceId(){
            let nonconformanceList = this.$store.state.nonconformances;  //nonconformance list
            let digerID = _.findIndex(nonconformanceList, item => item.id == 13);  //last element of old list
            let firstNewNonconformance = nonconformanceList[digerID+1];  //first element of new list
            return firstNewNonconformance.id - 1;
        }
    }
};
</script>

<style scoped>
.custom-select-choose {
    position: relative;
    border: 1px solid #ddd;
    border-radius: 3px;
    padding-top: 5px;
    padding-bottom: 5px;
    text-align: left;
    text-indent: 12px;
    user-select: none;
}
.custom-select-options-hide {
    display: none;
}
.custom-select-options-show {
    background-color: #eee;
    width: calc(100% - 30px);
    border-bottom-left-radius: 7px;
    border-bottom-right-radius: 7px;
    max-height: 300px;
    overflow-y: scroll;
    overflow-x: hidden;
    display: table-row;
    position: absolute;
    z-index: 1;
}
.custom-select-action-text {
    text-align: left;
    user-select: none;
    right: 20px;
}
.custom-select-row {
    cursor: pointer;
    padding-top: 5px;
    padding-bottom: 5px;
}
.custom-select-row:hover {
    background-color: #ddd;
}
.custom-select-checkbox {
    position: relative;
    left: 5px;
}
.arrow-up {
    position: absolute;
    top: 8px;
    right: 10px;
    border: 0.25em solid transparent;
    border-bottom-color: black;
}
.arrow-down {
    position: absolute;
    bottom: 8px;
    right: 10px;
    border: 0.25em solid transparent;
    border-top-color: black;
}
</style>

<i18n src="../../i18n/common.json"></i18n>

<i18n>
    {
        "tr": {
            "updateActionTicketTitle": "Aksiyon Planı Güncelle",
            "updateNonconformityTicketTitle": "Düzenleyici Faaliyet Güncelle",
            "createActionTicketTitle": "Aksiyon Planı Oluştur",
            "createNonconformityTicketTitle": "Düzeltici Faaliyet Oluştur",
            "nonconformanceType": "Uygunsuzluk Tanımı",
            "revisedDocumentInfo": "Tamamlanan Döküman Bilgisi",
            "urgentActionText": "Acil Alınacak Aksiyonlar",
            "reasonAnalysisText": "Kök Neden Analizi",
            "predictedDate": "Öngörülen Gerçekleşme Tarihi",
            "auditDate": "Denetim Tarihi",
            "additionalFiles": "Ek Dosyalar",
            "action": "Genel Aksiyon Tanımları",
            "futureAction": "Genel Aksiyon Tanımları",
            "auditTicket":"Denetim",
            "actionTicket":"Aksiyon"
        },
        "en": {
            "updateActionTicketTitle": "Edit Action Plan",
            "createActionTicketTitle": "Create Action Plan",
            "updateNonconformityTicketTitle": "Edit Corrective Action",
            "createNonconformityTicketTitle": "Create Corrective Action",
            "nonconformanceType": "Description of Nonconformance",
            "revisedDocumentInfo": "Completed Document Information",
            "urgentActionText": "Urgent Actions to be taken",
            "reasonAnalysisText": "Root Cause Analysis",
            "predictedDate": "Estimated Completion Date",
            "auditDate": "Audit Date",
            "additionalFiles": "Additional Files",
            "action": "Action",
            "futureAction": "Future Action",
            "auditTicket":"Audit",
            "actionTicket":"Action"
        }
    }
</i18n>



// WEBPACK FOOTER //
// src/components/modals/CreateTicket.vue